import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../lib/api.js';

export default function CourseRedirect() {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    async function redirect() {
      try {
        const response = await api.get(`/api/courses/${id}`);
        const firstLesson = response.data?.lessons?.[0];
        if (firstLesson) {
          navigate(`/courses/${id}/lessons/${firstLesson.id}`, { replace: true });
        } else {
          // Fallback if no lessons are added yet
          navigate('/courses', { replace: true });
        }
      } catch (err) {
        navigate('/courses', { replace: true });
      }
    }
    redirect();
  }, [id]);

  return (
    <div className="flex-1 min-h-screen bg-background flex items-center justify-center text-on-surface-variant font-medium">
      <div className="flex flex-col items-center gap-3 select-none">
        <div className="w-8 h-8 border-2 border-error border-t-transparent rounded-full animate-spin"></div>
        <span>Opening syllabus...</span>
      </div>
    </div>
  );
}
